<template>
    <div class="report">
        <div class="survey-head">
            <img class="banner" :src="banner.url" alt="业绩推介图片" />
            <div class="h-wrap">
                <div class="h-title">{{ title }}</div>
            </div>
        </div>
        <index-bar :bars="indexBar"></index-bar>
        <div class="survey">
            <!-- 财务报告 -->
            <div :id="String(indexBar[0]).replace(/\s+/g, '')" class="wrap">
                <div class="title">
                    <p class="content">{{ String(indexBar[0]).replace(/\s+/g, '') }}</p>
                </div>
                <sample-selector
                    :menus-list="['全部日期', ...financialMenusList]"
                    :select-item="financialSelectItem"
                    @changeItem="changeFinancialItem"
                />
                <div class="box">
                    <a v-for="(item, index) in showFinancialList" :key="index" class="item" target="_blank" :href="item.pdf.url">
                        <div class="image">
                            <img :src="item.cover.url" />
                        </div>
                        <div class="text">
                            {{ item.title }}
                            <img class="download" src="@/assets/images/investorRelation/download.png" alt="" />
                        </div>
                    </a>
                </div>
            </div>
            <!-- 投资者推介 -->
            <div :id="String(indexBar[1]).replace(/\s+/g, '')" class="wrap">
                <div class="title">
                    <p class="content">{{ String(indexBar[1]).replace(/\s+/g, '') }}</p>
                </div>
                <sample-selector
                    :menus-list="['全部日期', ...promotionMenusList]"
                    :select-item="promotionSelectItem"
                    @changeItem="changePromotionItem"
                />
                <div class="box">
                    <a v-for="(item, index) in showPromotionList" :key="index" class="item" target="_blank" :href="item.pdf.url">
                        <div class="image">
                            <img :src="item.cover.url" />
                        </div>
                        <div class="text">
                            {{ item.title }}
                            <img class="download" src="@/assets/images/investorRelation/download.png" alt="" />
                        </div>
                    </a>
                </div>
            </div>
            <!-- 投关活动 -->
            <div :id="String(indexBar[2]).replace(/\s+/g, '')" class="wrap">
                <div class="title">
                    <p class="content">{{ String(indexBar[2]).replace(/\s+/g, '') }}</p>
                    <router-link :to="{ name: 'reportList' }" class="view-all">
                        查看全部
                        <icon class="right-arrow" name="arrow-down"></icon>
                    </router-link>
                </div>
                <ul class="show-list">
                    <li v-for="(item, index) in meetList.slice(0, 4)" :key="item.title" @click="openReport(index)">
                        <div class="list-order">
                            <icon class="order-img" name="vector"></icon>
                            <p class="order-num">{{ index + 1 }}</p>
                        </div>
                        <div class="list-content">
                            <p class="list-title">{{ item.title }}</p>
                            <p class="list-date">{{ item.date }}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 近期要闻 -->
            <div :id="String(indexBar[3]).replace(/\s+/g, '')" class="wrap">
                <div class="title">
                    <p class="content">{{ String(indexBar[3]).replace(/\s+/g, '') }}</p>
                    <router-link :to="{ name: 'recentList' }" class="view-all">
                        查看全部
                        <icon class="right-arrow" name="arrow-down"></icon>
                    </router-link>
                </div>
                <ul class="show-list">
                    <li v-for="(item, index) in newList.slice(0, 4)" :key="item.title" @click="openRecent(item.id)">
                        <div class="list-order">
                            <icon class="order-img" name="vector"></icon>
                            <p class="order-num">{{ index + 1 }}</p>
                        </div>
                        <div class="list-content">
                            <p class="list-title">{{ item.title }}</p>
                            <p class="list-date">{{ item.newsTime }}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 可持续发展 -->
            <div :id="String(indexBar[4]).replace(/\s+/g, '')" class="wrap">
                <div class="title">
                    <p class="content">{{ String(indexBar[4]).replace(/\s+/g, '') }}</p>
                </div>
                <div class="banner" @click="openSustainable">
                    <img class="banner-img" src="@/assets/images/investorRelation/sustainable.png" alt="可持续发展" />
                    <div class="banner-title">透过每一次传递放大价值</div>
                </div>
                <div class="desc">
                    我们认为，在实现公司经营目标，为股东创造长远价值的同时， 促进环境与社会可持续发展，是顺丰所肩负的责任。
                    您的每一次托付，既是承诺更是信任。 顺丰致力，透过每一次传递，与您一同促进合作、造就美好，持续放大价值。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import indexBar from './components/index-bar.vue'
import sampleSelector from './components/sample-selector.vue'
export default {
    name: 'Report',
    components: {
        indexBar,
        sampleSelector
    },
    data() {
        return {
            banner: {
                url: ''
            },
            title: '',
            indexBar: [],
            financialMenusList: [],
            financialSelectItem: '全部日期',
            financialList: [],
            promotionMenusList: [],
            promotionSelectItem: '全部日期',
            promotionList: [],
            meetList: [],
            newList: []
        }
    },
    computed: {
        // 财务显示list
        showFinancialList() {
            if (this.financialSelectItem === '全部日期') {
                return this.financialList
            }
            return this.financialList.filter(item => String(item.year) === String(this.financialSelectItem))
        },
        // 投资者推介显示list
        showPromotionList() {
            if (this.promotionSelectItem === '全部日期') {
                return this.promotionList
            }
            return this.promotionList.filter(item => String(item.year) === String(this.promotionSelectItem))
        }
    },
    async created() {
        await this.initBanner()
        await this.initIndexBar()
        await this.initFinancial()
        await this.initPromotion()
        await this.initMeet()
        await this.initNew()
    },
    methods: {
        changeFinancialItem(item) {
            this.financialSelectItem = String(item)
        },
        changePromotionItem(item) {
            this.promotionSelectItem = String(item)
        },
        async initBanner() {
            // 图片信息
            const res = await ajax.investorReport()
            if (res) {
                this.banner = res.mobileBanner
                this.title = res.title
            }
        },
        async initIndexBar() {
            // 选择条
            const homeRes = await ajax.getHomeMenus()
            const { menus = [] } = homeRes
            const investorRelationItem = menus.find(i => i.key === 'investorRelation')
            const { children } = investorRelationItem
            const reportBar = children.find(i => i.key === 'report')
            this.indexBar = reportBar.indexBar
        },
        async initFinancial() {
            // 财务报告
            const financialRes = await ajax.investorFinancialReport()
            const {
                list,
                yearList: { arr }
            } = financialRes
            this.financialMenusList = arr
            this.financialList = list
        },
        async initPromotion() {
            // 投资者推介
            const promotionRes = await ajax.investorPromotion()
            const {
                list,
                yearList: { arr }
            } = promotionRes
            this.promotionMenusList = arr
            this.promotionList = list
        },
        async initMeet() {
            const meetRes = await ajax.investorMeet()
            const { list } = meetRes
            this.meetList = list
        },
        async initNew() {
            const newRes = await ajax.investorNews({ params: { _sort: 'newsTime:DESC' } })
            this.newList = newRes
        },
        openReport(index) {
            this.$router.push({
                name: 'reportList',
                query: {
                    index
                }
            })
        },
        openRecent(id) {
            this.$router.push({
                name: 'recentList',
                query: {
                    id
                }
            })
        },
        openSustainable() {
            this.$router.push({
                name: 'sustainable'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.report {
    .survey-head {
        position: relative;
        .banner {
            width: 100%;
            display: block;
        }
        .h-wrap {
            position: absolute;
            left: 40px;
            top: 80px;
            font-weight: 500;
            font-size: 60px;
            color: #fff;
        }
    }
    .survey {
        .wrap {
            margin-top: 60px;
            .title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 30px;
                padding: 0 40px;
                .content {
                    font-weight: 600;
                    font-size: 42px;
                    color: #333;
                }
                .view-all {
                    display: flex;
                    align-items: center;
                    font-weight: 400;
                    font-size: 26px;
                    color: #333;
                    .right-arrow {
                        width: 20px;
                        transform: rotate(-90deg);
                        margin-left: 10px;
                        position: relative;
                        bottom: 2px;
                        fill: #333;
                    }
                }
            }
            .box {
                overflow-x: auto;
                margin-top: 36px;
                padding: 0 30px;
                width: 100vw;
                display: flex;
                .item {
                    border-radius: 20px;
                    background-color: #f5f5f5;
                    display: flex;
                    margin: 0 10px;
                    flex-direction: column;
                    .image {
                        flex: 1;
                        img {
                            height: 450px;
                            max-width: 90vw;
                            border-top-left-radius: 20px;
                            border-top-right-radius: 20px;
                        }
                    }
                    .text {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 26px 20px;
                        font-weight: 500;
                        font-size: 24px;
                        color: #303030;
                        .download {
                            width: 28px;
                        }
                    }
                }
            }
            .show-list {
                display: flex;
                flex-direction: column;
                padding: 0 40px;
                li {
                    display: flex;
                    margin-bottom: 40px;
                    .list-order {
                        position: relative;
                        margin-right: 16px;
                        .order-img {
                            width: 42px;
                        }
                        .order-num {
                            position: absolute;
                            left: 14px;
                            top: 6px;
                            font-weight: 500;
                            font-size: 28px;
                            color: #fff;
                        }
                    }
                    .list-content {
                        .list-title {
                            width: 620px;
                            font-weight: 600;
                            font-size: 32px;
                            color: #333333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .list-date {
                            font-weight: 400;
                            font-size: 26px;
                            color: #ce0e2d;
                        }
                    }
                }
            }
            .banner {
                position: relative;
                margin-bottom: 30px;
                .banner-img {
                    height: 400px;
                }
                .banner-title {
                    position: absolute;
                    left: 40px;
                    top: 110px;
                    width: 490px;
                    font-weight: 600;
                    font-size: 70px;
                    color: #fff;
                }
            }
            .desc {
                padding: 0 40px;
                margin-bottom: 10px;
                font-weight: 400;
                font-size: 26px;
                color: #333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/report.vue